import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  viewRoleController,
  editRoleController,
  subAdminModuleListController,
  adminTypeListController,
} from "../../services/subAdminServices/subAdminServices";
import { toast } from "react-toastify";
import { Checkbox, FormControlLabel } from "@mui/material";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useButtonLoader from "../../hooks/useButtonLoader";

const EditRole = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [roleDetails, setRoleDetails] = useState({});
  const [moduleName, setModuleName] = useState([]);
  const [permissionArray, setPermissionArray] = useState([]);
  const [errors, setErrors] = useState({});
  const [loader, show, hide] = useFullPageLoader();
  const [submitButton, setSubmitButton] = useButtonLoader();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRoleDetails({
      ...roleDetails,
      [name]: value,
    });
  };

  const fetchModuleList = async () => {
    try {
      show();
      const response = await subAdminModuleListController();
      if (response?.data?.code === 200) {
        setModuleName((prevModuleName) => [
          ...prevModuleName,
          ...(response?.data?.data || []).map((item) => ({
            ...item,
            access: item.access.split(",").map(Number), // Convert to numbers
          })),
        ]);
        hide();
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
        hide();
      }
    } catch (e) {
      console.log("Error fetching module list:", e.message);
      hide();
    }
  };

  const fetchRoleDetails = async () => {
    try {
        show();
        const response = await viewRoleController(id);  // Ensure you're using the correct controller

        if (response?.data?.code === 200) {
            const roleData = response?.data?.data; // Role object
            setRoleDetails(roleData); 

            console.log('Fetched Role Data:', roleData);

            // Process moduleAccess data to create permissionArray
            const moduleAccessData = roleData?.moduleAccess || [];

            const formattedPermissions = moduleAccessData.reduce((acc, { accessId, moduleId }) => {
                const existingModule = acc.find((item) => item.moduleKey === moduleId);

                if (existingModule) {
                    existingModule.accessKey.push(Number(accessId));
                } else {
                    acc.push({
                        moduleKey: moduleId,
                        accessKey: [Number(accessId)],
                    });
                }
                return acc;
            }, []);

            setPermissionArray(formattedPermissions);
            console.log('Formatted Permissions:', formattedPermissions);
            hide();
        } else {
            toast.error(response?.response?.data?.message || response?.data?.message);
            hide();
        }
    } catch (e) {
        console.log("Error fetching role details:", e.message);
        hide();
    }
};


  // Checkbox Handler
  const checkBoxHandler = (e, accessId, moduleId, index) => {
    const selectedObjectIndex = permissionArray.findIndex(
      (module) => module.moduleKey === moduleId
    );
    const newPermissionArray = [...permissionArray];

    if (selectedObjectIndex === -1) {
      newPermissionArray.push({
        moduleKey: moduleId,
        accessKey: [accessId],
      });
    } else {
      const accessKeyArray = newPermissionArray[selectedObjectIndex].accessKey;
      const accessIndex = accessKeyArray.indexOf(accessId);

      if (accessIndex !== -1) {
        accessKeyArray.splice(accessIndex, 1);
      } else {
        accessKeyArray.push(accessId);
      }

      // If the accessKey array becomes empty, remove the corresponding object.
      if (accessKeyArray.length === 0) {
        newPermissionArray.splice(selectedObjectIndex, 1);
      }
    }

    setPermissionArray(newPermissionArray);
  };

  // Validate Input Field
  const validation = () => {
    let validationStatus = true;
    const error = {};
    if (!roleDetails.role) {
      validationStatus = false;
      error["role"] = "Role Name is Mandatory *";
    }
    setErrors(error);
    return validationStatus;
  };

  // Edit Role Handler
  const editRole = async (e) => {
    e.preventDefault();
    const status = validation();
    if (status) {
      try {
        setSubmitButton(true);
        const response = await editRoleController({
          id: roleDetails.id,
          role: roleDetails.role,
          permissions: permissionArray,
        });
        
        if (response?.data?.code === 200) {
          toast.success(response?.data?.message);
          navigate(-1);
          setSubmitButton(false);
        } else {
          toast.error(
            response?.response?.data?.message || response?.data?.message
          );
          setSubmitButton(false);
        }
      } catch (e) {
        console.log(e.message);
        setSubmitButton(false);
      }
    }
  };

  useEffect(() => {
    fetchModuleList();
    fetchRoleDetails();
  }, [id]);

  return (
    <div className="main-panel">
      <div className="content-wrapper">
        <div className="page-header">
          <h2 className="page-title">
            <span
              className="page-title-icon bg-gradient-primary text-white me-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <i className="mdi mdi-chevron-double-left"></i>
            </span>
            Edit Role
          </h2>
          <nav aria-label="breadcrumb"></nav>
        </div>
        {loader}
        <div className="wrap_Add_retailer">
          <div className="col-md- grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <form className="form-sample" onSubmit={editRole}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Role Name*
                        </label>
                        <div className="col-sm-9 text-start">
                          <input
                            type="text"
                            className="form-control"
                            name="role"
                            value={roleDetails.role || ""}
                            onChange={handleInputChange}
                          />
                          {errors.role && (
                            <span className="error-text">{errors.role}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row mt-4">
                    <div className="col-12">
                    </div>
                    {moduleName.map((item, index) => (
                      <React.Fragment key={++index}>
                        <div className="col-6 mb-4 text-start">
                          <h5>{item?.name}</h5>
                          <div className="permission-checkboxes">
                            {item.access.map((accessId) => {
                              const labelValue =
                                accessId === 1
                                  ? "Add"
                                  : accessId === 2
                                  ? "Edit"
                                  : accessId === 3
                                  ? "View"
                                  : accessId === 4
                                  ? "Delete"
                                  : accessId === 5
                                  ? "Status"
                                  : accessId === 6
                                  ? "Request"
                                  : null;

                              return (
                                <FormControlLabel
                                  key={accessId}
                                  label={labelValue}
                                  checked={permissionArray.some(
                                    (module) =>
                                      module &&
                                      module.moduleKey === item.id &&
                                      module.accessKey &&
                                      module.accessKey.includes(
                                        Number(accessId)
                                      )
                                  )}
                                  control={
                                    <Checkbox
                                      onChange={(e) =>
                                        checkBoxHandler(
                                          e,
                                          accessId,
                                          item.id,
                                          index
                                        )
                                      }
                                    />
                                  }
                                />
                              );
                            })}
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                  
                  <div className="row mt-4">
                    <div className="col-12 text-center">
                      <button
                        className="btn btn-gradient-primary me-2"
                        type="submit"
                        disabled={submitButton.loading}
                        onClick={editRole}
                      >
                        {submitButton.loading ? "Updating..." : "Update"}
                      </button>
                      <button
                        className="btn btn-light"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRole;